import { processOfflineQueue } from "./queue";
import { setupAutoSync } from "./sync";

let initialized = false;

export const initOfflineSupport = () => {
  if (initialized || typeof window === "undefined") {
    return;
  }

  initialized = true;

  const attemptSync = () => {
    if (navigator.onLine) {
      processOfflineQueue();
    }
  };

  window.addEventListener("online", attemptSync);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      attemptSync();
    }
  });

  // Set up auto-sync for pending records
  setupAutoSync();

  // Run once on startup
  attemptSync();
};


